import React, { Component } from 'react'
import { connect } from 'react-redux'
import css from './styles.scss'
import globalCss from '../../../scss/global.scss'

import DataSourceSpreadsheet from '../DataSourceSpreadsheet'
import datasource from '../lib/datasource'

const SPACE_CHAR = ' '
const NEWLINE_CHAR = '\n'

export class DataSource extends Component {
  constructor (props) {
    super(props)

    this.datasourceHelper = datasource.datasource
    this.id = this.props.match.params.dataSourceId
    this.state = {
      rows: [],
      scroll: { x: 0, y: 0 },
      name: '',
      saved: false,
      selected: false,
      loading: false,
      saving: false,
      deleting: false,
      update: false,
      addingColumn: false,
      columns: []
    }
    this.field = null
    this.active = null
  }

  fetchDataSource () {
    if (!this.id) {
      return Promise.resolve([])
    }

    return fetch(`/api/v1/data_sources/${this.id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`
      }
    })
      .then(res => {
        if (res.status === 200) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          return false
        }

        return data
      })
  }

  componentDidMount () {
    this.setState({
      loading: true
    }, () => {
      this.fetchDataSource().then(dataSource => {
        this.setState({
          name: dataSource.name,
          description: dataSource.description,
          rows: dataSource.data,
          loading: false,
          columns: dataSource.columns
        })
      })
    })
  }

  handleOnFieldChange = (rowId, field, value) => {
    const { rows } = this.state
    const row = rows.find(({ _index }) => (_index === rowId))
    const originalValue = this.handleExtendedInput(value, SPACE_CHAR, NEWLINE_CHAR)
    if (row[field] === originalValue) {
      return
    }
    this.setState({
      rows: this.datasourceHelper.editCell(rows, rowId, field, originalValue)
    })
  }

  handleAddingColumn = () => {
    this.setState(prevState => ({ addingColumn: !prevState.addingColumn }), () => {
      if (this.state.addingColumn) {
        document.getElementById('column-input').focus()
      }
    })
  }

  handleAddColumn = submit => {
    submit.preventDefault()

    const { columns, rows } = this.state
    const enteredColumnName = document.getElementById('column-input').value

    if (columns.includes(enteredColumnName)) {
      return alert('Error: A column already exists with that name')
    }

    if (!this.datasourceHelper.columnNameIsValid(enteredColumnName)) {
      return alert('Error: Column name is invalid')
    }

    if (columns.length === 50) {
      return alert('Error: Max columns is 50')
    };

    const appendedColumnName = rows.map(row => {
      row[enteredColumnName] = ''
      return row
    })

    this.setState(prevState => {
      return {
        columns: [...prevState.columns, enteredColumnName],
        rows: !columns.length ? [{ [enteredColumnName]: '' }] : appendedColumnName,
        addingColumn: false
      }
    })
  }

  handleAddRow = () => {
    this.setState(prevState => {
      return {
        rows: [...prevState.rows, {}]
      }
    })
  }

  save = () => {
    if (this.state.saving || !this.state.rows.length) return

    this.setState({ saving: true }, () => {
      this.saveDataSource().then(_ => {
        this.setState({
          saved: true,
          saving: false
        })
      })
    })
  }

  saveDataSource () {
    return fetch(`/api/v1/data_sources/${this.id}`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`,
        'Content-Type': 'application/json'
      },
      body: this.getBodyData()
    })
      .then(res => {
        if (res.status === 201) {
          return res.json()
        }
        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          return false
        }
        return true
      })
  }

  getBodyData () {
    const { name, description, rows, columns } = this.state
    const body = {
      name,
      description,
      columns,
      data: this.datasourceHelper.rowsForAPI(rows)
    }

    return JSON.stringify(body)
  }

  handleOnRowSelection = index => {
    const { rows } = this.state
    const toggle = rows.find(({ _index }) => _index === Number(index))._checked
    this.setState({
      rows: this.datasourceHelper.editCell(rows, index, '_checked', !toggle)
    })
  }

  handleOnDeleteColumn = name => {
    if (!confirm(`Confirm delete column ${name}?`)) return

    const scrollX = document.getElementById('widthReference').scrollLeft
    const scrollY = document.querySelector('.SpreadsheetGridScrollWrapper_scrollable').scrollTop
    const scroll = { x: scrollX, y: scrollY }

    this.updateSpreadsheet()
    this.setState({
      rows: this.datasourceHelper.deleteColumn(this.state.rows, this.state.columns, name),
      columns: this.state.columns.filter(column => column !== name),
      selected: false,
      scroll
    })
  }

  handleDeleteRowSelection = () => {
    const { rows } = this.state
    if (!rows.length) {
      return
    }
    if (this.field) {
      this.field.value = ''
    }
    const filteredRows = this.datasourceHelper.deleteSelectedRows(rows)
    const newRow = {}
    if (!filteredRows.length) {
      Object.keys(rows[0]).filter(key => !key.startsWith('_')).forEach(key => { newRow[key] = '' })
    }

    this.setState({
      rows: Object.keys(newRow).length ? [newRow] : filteredRows,
      selected: false
    })
  }

  delete = () => {
    if (this.state.deleting) return
    if (!confirm(`Confirm delete data source ${this.state.name}?`)) return

    this.setState({ deleting: true }, this.deleteDataSource)
  }

  deleteDataSource () {
    return fetch(`/api/v1/data_sources/${this.id}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${this.props.auth.bearerToken}`,
        'Content-Type': 'application/json'
      }
    })
      .then(res => {
        if (res.status === 204) {
          return true
        }

        return {
          _error: res.statusText
        }
      }).then(data => {
        if (data._error) {
          alert(data._error)
        }

        window.location.href = '/data'
      })
  }

  updateSpreadsheet = () => {
    this.setState({
      update: true
    }, () => {
      this.setState({
        update: false
      })
    })
  }

  extendedField = input => {
    if (!this.state.selected) {
      this.setState({
        selected: true
      })
    }
    this.active = input
    this.field = document.getElementById('extended-field')
    this.field.value = this.handleExtendedInput(this.active.value, SPACE_CHAR, NEWLINE_CHAR)
    this.active.oninput = evt => {
      this.field.value = this.handleExtendedInput(evt.target.value, SPACE_CHAR, NEWLINE_CHAR)
    }
  }

  handleExtendedInput = (value, charToReplace, charToAdd) => {
    let newValue = ''
    for (const char of value) {
      if (char === charToReplace) newValue += charToAdd
      else newValue += char
    }
    return newValue
  }

  handleClearCell = () => {
    if (!this.state.selected) {
      return
    }
    this.field.value = ''
    this.handleReportValue()
  }

  handleReportValue = () => {
    const rowId = Number(this.active.parentElement.getAttribute('data-row'))
    const column = this.active.parentElement.getAttribute('data-column')
    this.handleOnFieldChange(rowId, column, this.handleExtendedInput(this.field.value, NEWLINE_CHAR, SPACE_CHAR))
  }

  handleExtendedChange = evt => {
    this.active.value = this.handleExtendedInput(evt.target.value, NEWLINE_CHAR, SPACE_CHAR)
  }

  withBlur = (event, cb) => {
    event.target.blur()

    return cb()
  }

  render () {
    const { name, loading, saving, selected, deleting, addingColumn, rows, columns, update, scroll } = this.state
    const { app: { secondaryColor } } = this.props
    const hasRowSelection = rows.some(row => row._checked)

    if (update) {
      return null
    }

    if (loading) {
      return (<div>Loading...</div>)
    }

    let addColumnComponent
    if (addingColumn) {
      addColumnComponent = (
        <form autoComplete='off' onSubmit={this.handleAddColumn}>
          <input type='text' className={css.input} id='column-input' placeholder='Enter a Column Name...' />
          <button type='submit' className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Add</button>
          <button type='button' onClick={this.handleAddingColumn} className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Cancel</button>
        </form>
      )
    } else {
      addColumnComponent = (<button onClick={this.handleAddingColumn} className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Add Column</button>)
    }

    let bulkDeleteComponent
    if (hasRowSelection) {
      bulkDeleteComponent = (<button onClick={this.handleDeleteRowSelection} className={css.btnAdd} style={{ backgroundColor: secondaryColor }}>Delete Selected</button>)
    }

    return (
      <div className={css.bg}>
        <article className={css.wrapper}>
          <header className={css.header}>
            <h3 className={css.h3}>
              Data Source: {name}
            </h3>
          </header>
          <div className={css.topBar}>
            <div className={css.col1}>
              {addColumnComponent}
              {bulkDeleteComponent}
            </div>
            <div className={css.col2}>
              <button onClick={this.handleAddRow} className={css.btnAdd} style={{ backgroundColor: secondaryColor, visibility: columns.length ? 'visible' : 'hidden' }}>Add Row</button>
            </div>
          </div>
          <div className={css.topInput}>
            <i className={`${globalCss.iconX} ${css.inputX}`} onClick={this.handleClearCell} />
            <textarea
              type='text'
              className={css.extendedInput}
              onChange={this.handleExtendedChange}
              onBlur={this.handleReportValue}
              id='extended-field'
              disabled={!selected}
            />
          </div>
          <div className={css.content} id='widthReference'>
            <DataSourceSpreadsheet
              rows={this.datasourceHelper.rowsForSpreadsheet(rows)}
              columns={this.state.columns}
              onFieldChange={this.handleOnFieldChange}
              onRowSelection={this.handleOnRowSelection}
              onDeleteColumn={this.handleOnDeleteColumn}
              scroll={scroll}
              extendedField={this.extendedField}
            />
          </div>
        </article>
        <div className={css.bottomOptions}>
          <button onClick={click => this.withBlur(click, this.save)} className={css.create}>{saving ? 'Saving...' : 'Save'}</button>
          <button onClick={click => this.withBlur(click, this.delete)} className={css.bottomBtn}>{deleting ? 'Deleting Data Source...' : 'Delete Data Source'}</button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { auth, app } = state
  return {
    auth,
    app
  }
}

export default connect(mapStateToProps)(DataSource)



// WEBPACK FOOTER //
// /app/js/components/DataSource/index.js